module.exports = __webpack_public_path__ + "img/circle_green.5cbd858d.png";